import { useContext } from 'react'
import { Pressable, View } from 'react-native'
import { useRouter } from 'expo-router'

import { cn } from '@/utils/cn'
import { Notifications } from '@/components/icon'

import { NotificationsContext } from './providers/notifications'

function NotificationButton({ isHome = false }: { isHome?: boolean }) {
  const router = useRouter()

  const { hasNewNotifications } = useContext(NotificationsContext)

  return (
    <Pressable className={'size-10 items-center justify-center'} onPress={() => router.push('/notification')}>
      {({ pressed }) => (
        <>
          {hasNewNotifications && (
            <View
              className={cn(
                'absolute right-1.5 top-1.5 size-1.5 rounded-full bg-danger',
                isHome && 'size-2 border-2 border-white'
              )}
            />
          )}
          <Notifications
            className={cn('size-6', isHome ? 'text-white' : 'text-text-tertiary', pressed && 'opacity-50')}
          />
        </>
      )}
    </Pressable>
  )
}

export default NotificationButton
